// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_2a-3";
export var dialog = "_2a-0";
export var divClassnameSwatch = "_2a-8";
export var flexSwatch = "_2a-4";
export var header = "_2a-1";
export var styleAttributeSwatch = "_2a-7";
export var swatch = "_2a-2";
export var textHeaderSwatch = "_2a-5";
export var webSwatch = "_2a-6";